import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'sent-reset.component.html',
    selector: 'ca-sent-reset',
    standalone: false
})
export class SentResetComponent {
  @Input() sent: boolean;
  @Output() reset = new EventEmitter();
}
